<template>
    <div id="vehicle-warranty-detail" class="admin-page-content asset-view list-view" v-if="vehicleId != '' && canAccessPage">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <section class="bg-white data-table border-top-table-fl">
            <h2>Campaigns & Field Fixes</h2>
            <vue-good-table ref="listAssetCampaignTable" title="Vehicle Campaign/Recall" 
                :columns="campaignColumns"
                :rows="campaignRows" max-height="600px" :totalRows="totalRecords" 
                :pagination-options="{
                    enabled: true,
                    position: 'top',
                    mode: 'records',
                    perPage: 50,
                    perPageDropdown: [50, 100],
                    dropdownAllowAll: false,
                }" 
                :search-options="{
                    enabled: false,
                    placeholder: 'Search Asset Campaigns',
                }" 
                :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                }" 
                :sort-options="{
                    enabled: true,
                }"
            >
                <div slot="emptystate">
                    No Data Found.
                </div>
                <template slot="table-row" slot-scope="props" v-for="(row, key) in campaignRows">
                    <div :key="key">
                        <template>
                            <div v-if="props.column.field == 'link'">
                                <a v-on:click="goTogetDocumentPath($event, props.row)" title="View Document" href=""
                                    style="font-size: 15px;"><i class="fp-text-document"></i></a>
                            </div>
                            <div v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </div>
                        </template>
                    </div>
                </template>
            </vue-good-table>
        </section>
    </div>

</template>
<script>
import Vue from 'vue';
import { commonMixins } from '../mixins/commonMixins';
import { contractMixins } from '../mixins/contractMixins';
import { dataTableMixins } from '../mixins/dataTableMixins';

export default {
    name: "VehicleCampaignRecallDetails",
    mixins: [commonMixins, dataTableMixins, contractMixins],
    data: () => ({
        loading: false,
        campaignRows: [],
        campaignColumns: [
            {
                label: 'Field Fix Code',
                field: 'ffp_code',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "FFP Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Description',
                field: 'ffp_description',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "FFP Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Vin',
                field: 'vin',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vin", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },

            {
                label: 'Start Date',
                field: 'campaign_start_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
                // sortable:false
            },
            {
                label: 'End Date',
                field: 'campaign_end_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
                // sortable:false
            },
            {
                label: 'Status',
                field: 'status',
                fpFieldType: "option",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Claim Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Claim Date',
                field: 'claim_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Claim Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Claim Number',
                field: 'claim_number',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Claim Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Documents',
                field: 'link',
                sortable: false,
                filterable: false,
            },
        ],
        totalRecords: 0,
        vehicleId: '',
        permissions: [],
        canAccessPage: false,
        isParentVehicleView: false,
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_view_campaign_recall') {
                        self.canAccessPage = true;
                        break;
                    }
                }
                if(this.isParentVehicleView){
                    this.getCampaignRecalls(this.vehicleId);
                }
            }

        }
    },
    mounted: function () {
        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
            this.vehicleId = segments[3];
            this.isParentVehicleView = true;
        }
        this.getPermissions();
    },
    methods: {
        getCampaignRecalls(id) {
            if (this.canAccessPage) {
                var self = this;
                self.loading = true;
                self.vehicleId = id;

                $.ajax({
                    url: process.env.ROOT_API + '/campaign-recall-vin/list',
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data: { vehicleId: self.vehicleId },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.campaignRows = data.content.row;
                            if (self.campaignRows === undefined) {
                                self.campaignRows = [];
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true, 'asset-load-view')

                    }
                });
            }
        },
        goTogetDocumentPath(event, row) {
            event.preventDefault();
            var self = this;
            var path = row.link;
            var flag = '';
            var id = 0;
            if (row.campaign_id > 0) {
                id = row.campaign_id;
                flag = 'campaign';
            }
            self.getDocumentPath(id, path, flag);
        },
        emitDataToParent(){
            this.$emit("vehicle-recall-campaign-data",this.campaignRows);
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/VehicleCampaignRecallDetails.vue